<template>
  <div class="flex-col gap-md" v-bind:key="automationKey">
    <dd-header-card
        header="Selectie details">
      <dd-card-stacked-list>
        <dd-card-list-row>
          <dd-card-list-item title="Selectie">
            {{ searchDescription }}
          </dd-card-list-item>
          <dd-card-list-item title="Sub selectie's">
            {{ extendingSearchesDescription }}
          </dd-card-list-item>
        </dd-card-list-row>
        <AutomationSearchDescription/>
      </dd-card-stacked-list>
    </dd-header-card>
    <dd-header-card
        header="Selectie overzicht"
        :wide-content="hasSearchables"
    >
      <template #action>
        <dd-input
            v-model="customerName"
            @input="onSearch"
            placeholder="Zoek op voor- of achternaam"
        />
      </template>
      <template v-if="!loaded">
        Laden ...
      </template>
      <dd-main-table
          v-else-if="hasSearchables"
          @load-page="onLoadPage"
          :initial-load-page-object="loadPageObject"
          :rows="searchables"
          :headers="tableHeaders"
          :paginator="searchablesPagination"
          :has-select="false"
      />
      <template v-else>
        Er zijn momenteel geen resultaten voor deze selectie.
      </template>
    </dd-header-card>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import search from '~/api/search'
import HTMLCell from '~/new_design_components/tables/cell_types/HTMLCell.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import AutomationSearchDescription from './AutomationSearchDescription.vue'
import CustomerAvatarCell from '~/new_design_components/tables/cell_types/CustomerAvatarCell.vue'

export default {
  name: 'AutomationSearchOverview.vue',
  components: {
    AutomationSearchDescription,
    HTMLCell,
  },
  data () {
    return {
      customerName: '',
      loaded: false,
      loading: false,
      loadPageObject: {
        perPage: 15,
        page: 1,
      },
      tableHeaders: [
        {
          title: 'Naam',
          key: (row) => row.name,
          typeComponent: HTMLCell
        },
        {
          title: 'Type',
          width: '150px',
          key: (row) => row.type,
        }
      ],
    }
  },
  created () {
    if (this.doesntSearchByCustomerModel) {
      this.tableHeaders = [
        {
          title: 'Klant',
          width: '200px',
          typeComponent: CustomerAvatarCell,
          key: (row) => row.customer?.data,
        },
        ...this.tableHeaders,
      ]
    }
    this.debounceFetchSearchables()
  },
  computed: {
    doesntSearchByCustomerModel () {
      return this.automationInterface?.search?.data?.model !== 'App\\Models\\Customer'
    },
    search () {
      return search
    },
    ...mapState(`$_automation_show`, [
      'searchables',
      'searchablesPagination',
    ]),
    ...mapGetters(`$_automation_show`, [
      'automationInterface',
      'automationKey',
      'hasSearchables',
      'isGlobal',
      'searchDescription',
      'extendingSearchesDescription'
    ]),
  },
  watch: {
    searchablesPagination () {
      this.loadPageObject = {
        page: this.searchablesPagination.current_page,
        perPage: this.searchablesPagination.per_page,
      }
    },
    automationKey () {
      this.debounceFetchSearchables()
    }
  },
  methods: {
    ...mapActions(`$_automation_show`, [
      'fetchSearchablesByGlobalAutomationConfiguration',
      'fetchSearchablesByAutomation'
    ]),
    onSearch () {
      this.loadPageObject = {
        ...this.loadPageObject,
        page: 1,
      }
      this.debounceFetchSearchables()
    },
    onLoadPage (pageObject) {
      this.loadPageObject = pageObject
      this.debounceFetchSearchables()
    },
    debounceFetchSearchables: debounce(function () {
      this.fetchSearchables()
    }, 500),
    fetchSearchables () {
      if (this.automationInterface === null) {
        return Promise.resolve()
      }

      this.loading = true

      if (this.isGlobal) {
        return this.fetchSearchablesByGlobalAutomationConfiguration({
          globalAutomationConfigurationId: this.automationInterface.id,
          page: this.loadPageObject.page,
          perPage: this.loadPageObject.perPage,
          name: this.customerName,
        }).then(() => {
          this.loaded = true
          this.loading = false
        })
      }
      return this.fetchSearchablesByAutomation({
        automation: this.automationInterface,
        page: this.loadPageObject.page,
        perPage: this.loadPageObject.perPage,
        name: this.customerName,
      }).then(() => {
        this.loaded = true
        this.loading = false
      })
    },
  }
}
</script>

<style scoped>

</style>
